import axios from "axios";

export const expenseApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/stk-expenses`,
  headers: {
    "Content-Type": "application/json",
  },
});
